(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("create_customer");
    if (!form) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener("click", submitForm);
    form.addEventListener("submit", submitForm);

    function submitForm(e) {
      let isValid = true;

      const requiredFields = [
        "first_name",
        "last_name",
        "email",
        "customer_password",
        "customer[privacy_policy]",
      ];

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      for (const field of requiredFields) {
        const input = form.querySelector(`[id="${field}"]`);

        if (
          "email" === input.type &&
          input.value &&
          !emailRegex.test(input.value)
        ) {
          input.dataset.valid = false;
          isValid = false;
          input.scrollIntoView({ behavior: "smooth", block: "center" });
          continue;
        }

        if ("checkbox" === input.type && !input.checked) {
          input.dataset.valid = false;
          isValid = false;
          continue;
        }

        if (!input.value.trim()) {
          input.dataset.valid = false;
          isValid = false;
          continue;
        }
      }

      if (!isValid) {
        e.preventDefault();
        return false;
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    for (const input of form.querySelectorAll("input")) {
      if (!input.hasAttribute("data-valid")) continue;

      input.addEventListener("input", function () {
        this.dataset.valid = true;
      });

      if ("checkbox" === input.type) {
        input.addEventListener("change", function () {
          this.dataset.valid = true;
        });
      }
    }
  });
})();
